import { gql } from '@apollo/client'
export const GET_ALL_USERS_RATINGS = gql`
  query GetAllsUserRatings($searchQuery: String, $limit: Int, $offset: Int) {
    getAllsUserRatings(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      count
      rows {
        id
        user_id
        rated_user_id
        # rating
        userQualified {
          name
          first_name
          last_name
        }
        userRated {
          name
          first_name
          last_name
        }
        comment
        group_id
        group_category_id
        feedback_type
        feedback_type_label
        user_type
        user_type_label
      }
    }
  }
`

export const GET_USER_RATING_BY_ID = gql`
  query GetUserRatingById($id: Int!) {
    getUserRatingById(id: $id) {
      id
      user_id
      rated_user_id
      # rating
      comment
      group_id
      group_category_id
      group_sub_category_id
      feedback_type
      feedback_type_label
      user_type
      user_type_label
      created_date
      userRated {
        name
        first_name
        last_name
      }
      # UsersRatingToGroup {
      #   id
      #   name
      # }
      # UsersRatingToGroupCategory {
      #   id
      #   name
      #   icon
      # }
    }
  }
`
export const GET_RATED_BY_USER = gql`
  query GetRatedByUser {
    getRatedByUser {
      average
      totalRating
      totalRatingCount
      totalPositiveRatings
      totalNegativeRatings
    }
  }
`

export const GET_ALL_RATINGS_BY_USER = gql`
  query GetAllRatingsByUserId(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $onlySearchById: Boolean
    $userId: Int
  ) {
    getAllRatingsByUserId(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      onlySearchById: $onlySearchById
      user_id: $userId
    ) {
      count
      rows {
        id
        created_date
        rated_user_id
        # rating
        comment
        feedback_type
        feedback_type_label
        user_type
        user_type_label
        userRated {
          name
          first_name
          last_name
        }
        # UsersRatingToGroup {
        #   id
        #   name
        # }
        # UsersRatingToGroupCategory {
        #   id
        #   name
        #   icon
        # }
      }
    }
  }
`

export const GET_ALL_USER_TYPES_RATING = gql`
  query GetAllUserTypes {
    getAllUserTypes {
      value
      label
    }
  }
`

export const GET_ALL_FEEDBACK_TYPE = gql`
  query GetAllFeedbackTypes {
    getAllFeedbackTypes {
      value
      label
    }
  }
`

export const GET_GROUPS_OPTIONS_BY_AREA = gql`
  query GetOptionsByArea($userType: String) {
    getOptionsByArea(user_type: $userType) {
      label
      value
    }
  }
`

export const GET_CATEGORIES_OPTIONS_BY_GROUP = gql`
  query GetOptionsCategoriesByArea($userType: String, $parentId: Int) {
    getOptionsCategoriesByArea(user_type: $userType, parent_id: $parentId) {
      label
      value
    }
  }
`

export const GET_SUB_CATEGORIES_OPTIONS_BY_CATEGORY = gql`
  query GetOptionsSubCategoriesByArea(
    $userType: String
    $parentCategoryId: Int
  ) {
    getOptionsSubCategoriesByArea(
      user_type: $userType
      parent_category_id: $parentCategoryId
    ) {
      label
      value
    }
  }
`

export const GET_ALL_USERS_QUALIFIED = gql`
  query GetAllUsersRated($searchQuery: String, $limit: Int, $offset: Int) {
    getAllUsersRated(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      rows {
        id
        name
        first_name
        last_name
        RoleOfUser {
          role_name
        }
        JobPositionOfUser {
          name
        }
      }
      count
    }
  }
`

export const CREATE_RATING = gql`
  mutation CreateUserRating($input: userRaitingInput!) {
    createUserRating(input: $input)
  }
`
export const UPDATE_RATING = gql`
  mutation UpdateUserRating(
    $updateUserRatingId: Int!
    $input: userRaitingInput!
  ) {
    updateUserRating(id: $updateUserRatingId, input: $input)
  }
`

export const DELETE_RATING = gql`
  mutation DeleteUserRating($deleteUserRatingId: Int!) {
    deleteUserRating(id: $deleteUserRatingId)
  }
`
